(function(){
    angular
        .module('app')
        .directive('ngSubmitchange', ngSubmitchange);

        ngSubmitchange.$inject = ['$timeout'];
        function ngSubmitchange($timeout){
            return {
            //restrict:'A',
            //replace: true,
            //transclude: true,
            //scope: { control : "=" },
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
	            	/*scope.$watch(function(newValue, oldValue) {
	                    console.log(ngModel.$modelValue);
	                }, true);*/
	                scope.$watch(function () {
	                	if(ngModel.$modelValue.length>0){
		                	element.val(ngModel.$modelValue.join(","));
		                }
		               //console.log("modV");
		               //console.log(ngModel.$modelValue);
		              //return ngModel.$modelValue;
		            }, function(newValue) {
		               console.log(newValue);
		            });
                    /*element.on('change', function() {
                        console.log(element.val());
                    });*/
                });
            }
          }
      }
})();